<template>
  <div>
    <el-table
      :data="list"
      border
      size="small"
      style="width: 1221px"
      height="600px"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="list.length == 0"
    >
      <el-table-column
        prop="createdAt"
        label="发起时间"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          {{ $util.ms2datetime(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="expiredAt"
        label="结束时间"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          {{
            scope.row.finishedAt > 0
              ? $util.ms2datetime(scope.row.finishedAt)
              : ""
          }}
        </template>
      </el-table-column>

      <el-table-column prop="event" label="事件" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.event }}
        </template>
      </el-table-column>

      <el-table-column prop="status" label="状态" align="center" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0"
            ><countdown-timer
              v-slot="timeObj"
              :isMiniSecond="true"
              :end="scope.row.expiredAt"
            >
              进行中（{{ timeObj.d ? timeObj.d + "天" : "" }}{{ timeObj.hh }}:{{
                timeObj.mm
              }}:{{ timeObj.ss }}后过期）
            </countdown-timer></span
          >
          <span v-if="scope.row.status == 1" style="color: rgb(46 207 71)"
            >已通过</span
          >
          <span v-if="scope.row.status == 2" style="color: red">已被否决</span>
          <span v-if="scope.row.status == 3" style="color: red">已过期</span>
          <span v-if="scope.row.status == 4">已被撤回</span>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="data"
        label="详情"
        align="center"
        width="60"
      >
        <template slot-scope="scope">
          <el-popover placement="right" trigger="hover" width="350">
            <textarea
              rows="15"
              style="width: 340px; height: 250px; line-height: 20px"
              v-model="scope.row.data"
            >
            </textarea>
            <span
              class="link-button"
              slot="reference"
              size="small"
              icon="el-icon-view"
              >查看</span
            >
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="creator" label="发起者" align="center" width="120">
      </el-table-column>
      <el-table-column
        prop="receivers"
        label="接收者"
        align="center"
        width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            :key="index + $util.uuid()"
            v-for="(item, index) in scope.row.receivers"
            >{{ item.name }}：{{ item.operation ? item.operation : "（未操作）"
            }}<br v-if="scope.row.receivers.length != index + 1" />
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <span
            v-if="
              scope.row.status == 0 &&
              scope.row.creator == $bizutil.getLoginUser().username
            "
            class="link-button"
            @click="cancel(scope.row)"
            >撤回</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import CountdownTimer from "@/components/CountdownTimer";
export default {
  data() {
    return {
      list: [],
    };
  },

  components: {
    CountdownTimer,
  },

  async created() {
    await this.loadMore();
  },

  methods: {
    async loadMore() {
      util.sequentialExecFunction(async () => {
        await this.loadList(this.list.length, 10);
      });
    },
    /**
     *
     */
    async loadList(offset, limit) {
      if (offset == 0) {
        this.list = [];
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/corpflow/queryCorpFlowVote`,
          {
            offset: offset,
            limit: limit,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.list = this.list.concat(listInResponse);
    },

    async cancel(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认撤回投票？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/corpflow/cancelCorpVote`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "撤回成功",
          type: "success",
        });

        await this.loadList(0, 10);
      } catch (e) {}
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__row td {
  padding: 0px 0;
}

.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}
</style>